module.exports = __webpack_public_path__ + "img/device_dongle.a1d43aca.png";